import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./components/Home";
import Services from "./components/Services";
import Experts from "./components/Experts";
import ProductDevelopment from "./components/ProductDevelopment";
import ProductMaintenance from "./components/ProductMaintenance";
import ITStaffing from "./components/ITStaffing";
import Training from "./components/Training";
import ManagedITServices from "./components/ManagedITServices";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsConditions from "./components/TermsConditions";

function App() {
  return (
    <BrowserRouter>
      <Routes>
<Route
  path="/services"
  element={<Services />}
/>
        <Route path="/" element={<Home />} />
        <Route
  path="/privacy-policy"
  element={<PrivacyPolicy />}
/>

<Route
  path="/terms-and-conditions"
  element={<TermsConditions />}
/>

        <Route
          path="/services/product-development"
          element={<ProductDevelopment />}
        />

        <Route
          path="/services/product-maintenance"
          element={<ProductMaintenance />}
        />

        <Route
          path="/services/it-staffing"
          element={<ITStaffing />}
        />

        <Route
          path="/services/training"
          element={<Training />}
        />

        <Route
          path="/services/managed-it-services"
          element={<ManagedITServices />}
        />
<Route path="/experts" element={<Experts />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;